import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { MsalInterceptor } from '@azure/msal-angular';
import { routes } from './app.routes';
import { errorInterceptor } from './http/error.interceptor';
import { provideMsal } from './msal.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideMsal(),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([
      errorInterceptor
    ])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    }
  ]
};
